import axios, { AxiosResponse } from 'axios'
import { ID } from '../../../../../../_metronic/helpers'
import {
  EspecialidadeDtoCreate,
  EspecialidadeDtoUpdate,
  EspecialidadesQueryResponse,
  EspecialidadeView,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const GET_ESPECIALIDADES_URL = `${API_URL}/especialidades`

/**
 * Busca especialidades
 * @param query string
 * @returns EspecialidadesQueryResponse
 */
export const getEspecialidades = (query?: string): Promise<EspecialidadesQueryResponse> => {
  return axios
    .get(`${GET_ESPECIALIDADES_URL}?${query}`)
    .then((d: AxiosResponse<EspecialidadesQueryResponse>) => d.data)
}

/**
 * Busca uma especialidade
 * @param especialidadeId Identificador de especialidade
 * @returns EspecialidadeView
 */
export const getEspecialidadeById = (especialidadeId: number): Promise<EspecialidadeView> => {
  return axios
    .get(`${GET_ESPECIALIDADES_URL}/${especialidadeId}`)
    .then((d: AxiosResponse<EspecialidadeView>) => d.data)
}

/**
 * Busca especialidades para o paciente
 * @param pacienteId Identificador do paciente
 * @param query string
 * @returns EspecialidadesQueryResponse - EspecialidadeView
 */
export const getEspecialidadesByPaciente = (
  pacienteId: number,
  query?: string
): Promise<EspecialidadesQueryResponse> => {
  return axios
    .get(`${GET_ESPECIALIDADES_URL}/paciente/${pacienteId}?${query}`)
    .then((d: AxiosResponse<EspecialidadesQueryResponse>) => d.data)
}

export const createEspecialidade = (
  especialidade: EspecialidadeDtoCreate
): Promise<EspecialidadeView> => {
  return axios.post(`${GET_ESPECIALIDADES_URL}`, especialidade)
}

export const editEspecialidade = (
  especialidade: EspecialidadeDtoUpdate
): Promise<EspecialidadeView> => {
  return axios.put(`${GET_ESPECIALIDADES_URL}`, especialidade)
}

export const updateEspecialidadeStatus = (id: ID, ativa: boolean): Promise<EspecialidadeView> => {
  return axios.put(`${GET_ESPECIALIDADES_URL}`, {
    id,
    ativa,
  })
}
